<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择一级分类',filterable:true,clearable:true,ischange:true,width:'200px'}" 
                :value="param.pcateid" 
                :list="catelists"
                v-show="param.isorder"
                @finish="(val)=> {
                    if(val.type=='change') {
                        param.pcateid=val.value;
                        param.ischange=true;
                        GetList();
                    }
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'请输入类型名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'添加分类'}" @finish="$parent.JUMPVIEW({name:'EsAddCates'})"/>
        </el-form-item>
        <el-form-item style="position:absolute;right:0;">
        <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
        <el-switch v-model="param.isorder" active-text="按二级分类搜索" 
            @change="(val)=>{
                this.param.pcateid='';
                this.param.key='';
                this.param.change=true;
                GetList();
            }" 
        />
        </div>
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div class="TTL-table top20" :ref="objloading" v-show="!param.isorder">
    <el-table :data="list" stripe="true" empty-text=""  @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="selection" />
        <el-table-column prop="name" label="分类名称" align="center"/>
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <el-table-column label="排序" align="center">
            <template #default="scope">
                <wcinput style="display:inline-flex;justify-content:center;text-align:center"
                    :option="{placeholder:'请输入排序',type:'input',ischange:true,isinput:true,iskeydown:true,width:'100px'}" 
                    :value="scope.row.sort"
                    @finish="(val)=> {
                        if(val.type=='change') {changeSort(scope.row.id,val.value)}
                    }"
                />
            </template>
        </el-table-column>
        <!-- <el-table-column label="是否显示" align="center">
            <template #default="scope">
            <div class="TTL-switch" style="display:inline-flex;justify-content:center;">
            <el-switch v-model="scope.row.isshow"
                @change="(val)=>{
                    changeCateIsshow(scope.row.id,scope.row.isshow ? 1 : 0);
                }" 
            />
            </div>
            </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center">
            <template #default="scope">
            <div class="TTL-btn-info">
            <wcbutton :option="{title:'编辑'}" @finish="EditCatesData(scope.row.id)"/>
            <wcbutton :option="{title:'删除',type:'del'}" @finish="DelCates(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>

<!-- 二级数据操作 -->
<div class="TTL-table top20" :ref="objloading" v-show="param.isorder">
    <el-table :data="list" stripe="true" empty-text=""  @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="selection" />
        <el-table-column label="分类图" align="center">
        <template #default="scope">
        <wcimage :option="{size:'middle'}" :value="scope.row.thumb" />
        </template>
        </el-table-column>
        <el-table-column prop="name" label="分类名称" align="center"/>
        <el-table-column prop="pname" label="所属一级分类" align="center"/>
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <el-table-column label="排序" align="center">
            <template #default="scope">
                <wcinput style="display:inline-flex;justify-content:center;text-align:center"
                    :option="{placeholder:'请输入排序',type:'input',ischange:true,isinput:true,iskeydown:true,width:'100px'}" 
                    :value="scope.row.sort"
                    @finish="(val)=> {
                        if(val.type=='change') {changeSort(scope.row.id,val.value)}
                    }"
                />
            </template>
        </el-table-column>
        <!-- <el-table-column label="是否显示" align="center">
            <template #default="scope">
            <div class="TTL-switch" style="display:inline-flex;justify-content:center;">
            <el-switch v-model="scope.row.isshow"
                @change="(val)=>{
                    changeCateIsshow(scope.row.id,scope.row.isshow ? 1 : 0);
                }" 
            />
            </div>
            </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'编辑'}" @finish="EditCatesData(scope.row.id)"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="DelCates(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>

    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <wcselect :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                    :value="handlevalue"
                    :list="handleinfos"
                    @finish="(val)=> {
                        changehandle(val.value)
                    }"
                />
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetList();
                    }"
                />
            </div>
        </div>
    </div>




</template>

<script>
import INTERFACE_MODEL_CATE from '@/Interface/Es/Goods/Cates';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'cates',
            param: {
                pcateid:'',
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
                isorder:false,
            },
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],
            catelists:[], //一级分类信息
        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
            this.GetParentCates(isfresh); //获取一级分类信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            var method=this.param.isorder ? 'GET_CHILD_LIST' : 'GET_PARENT_LIST';
            INTERFACE_MODEL_CATE[method](this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(val);
        },


        /** 删除分类信息 **/
        DelCates(id) {
            this.DelCatesData(id);
        },


        /** 编辑分类信息 **/
        EditCatesData(ids) {
            this.$parent.JUMPVIEW({name:'EsEditCates',param:{ids:ids}});
        },


        /** 删除文件信息操作 **/
        DelCatesData(ids) {
            INTERFACE_MODEL_CATE.DEL_CATES({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },  


        /** 批量操作 **/
        changehandle(index) {
            var ids=this.GetSelectDataIds(); //获取当前选中的id
            if(ids.length==0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
            ids=ids.join(',');
            if(index==1) this.DelCatesData(ids);    //批量删除
            if(index==2) this.EditCatesData(ids);   //批量修改
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 调整分类是否显示 **/
        changeCateIsshow(id,isshow) {
            INTERFACE_MODEL_CATE.CHANGE_CATES_ISSHOW({id:id,isshow:isshow}).then((res) => {
                 if(res.status > 0) return false;
            });
        },

        /** 调整愤怒类排序 **/
        changeSort(id,sort) {
            INTERFACE_MODEL_CATE.CHANGE_CATES_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
            });
        },


        /** 获取一级分类信息 **/
        GetParentCates(isfresh) {
            this.$method.GET_CATES_PARENT(isfresh).then((res) => {this.catelists=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
</style>